export const unitFaq = {
  head: {
    title: "Pytania i odpowiedzi jednostki",
    chip: "AI",
    subPre: "Odpowiedzi dotyczące konkretnie",
    subStrong: "tej jednostki",
    subPost: ". Agent sięgnie po nie w pierwszej kolejności, pomagając gościowi, który tu mieszka (np. kod do drzwi, specyfika tego apartamentu…). Dołącz zdjęcia lub filmy, a agent wyśle je zawsze wtedy, gdy gość będzie ich potrzebował.",
  },
  clone: {
    titleNoun: "pytania FAQ",
    itemNoun: "te pytania FAQ",
    buttonLabel: "Klonuj pytania",
  },

  copyOne: {
    title: "Kopiuj to pytanie",
    itemNoun: "pytanie",
  },
  loading: "Wczytywanie…",
  emptyList: "Nie ma jeszcze żadnych pytań. Dodaj pierwsze, aby agent wiedział, jak na nie odpowiadać.",
  list: {
    newQuestion: "Nowe pytanie",
    attachments: "{count} załącznik | {count} załączniki | {count} załączników",
    learnedTitle: "Dodane przez samouczenie",
    deleteTitle: "Usuń",
    copyTitle: "Kopiuj do innych jednostek",
  },
  form: {
    questionLabel: "Pytanie",
    answerLabel: "Odpowiedź agenta",
    qPlaceholder: "Pytanie · np. Jaki jest kod do drzwi?",
    aPlaceholder: "Odpowiedź · np. Kod do wejścia w budynku to 4512.",
    removeAttachment: "Usuń załącznik",
    uploading: "Przesyłanie…",
    attach: "Załącz",
    addQuestion: "Dodaj pytanie",
  },
  preview: {
    tag: "Podgląd · WhatsApp",
    online: "online",
    aiReception: "Recepcja AI",
    questionPlaceholder: "Wpisz pytanie gościa…",
    answerPlaceholder: "Wpisz odpowiedź, której udzieli agent…",
    videoFile: "Wideo",
    genericFile: "Plik",
    empty: "Wybierz lub utwórz pytanie, aby zobaczyć, jak odpowie agent.",
    hint: "Tak zobaczy to gość na swoim czacie",
  },
  footer: {
    saved: "Zapisano",
    save: "Zapisz zmiany",
  },
  errors: {
    load: "Nie udało się wczytać pytań.",
    attachNeedsQA: "Wpisz pytanie i odpowiedź przed dołączeniem plików.",
    attachNeedsSave: "Najpierw zapisz, aby móc dołączać pliki.",
    upload: "Nie udało się przesłać pliku.",
    deleteFile: "Nie udało się usunąć pliku.",
    save: "Nie udało się zapisać.",
  },
};
